export const promotionUploadInstructions = {
  title: 'Format Instructions',
  sections: [
    {
      title: 'Required Columns',
      variant: 'table',
      columns: ['Column', 'Required', 'Example'],
      rows: [
        ['article_code', 'Yes', '2301747'],
        ['vendor_id', 'Yes', '123456'],
        ['start', 'Yes', '2026-08-15'],
        ['end', 'Yes', '2026-08-31'],
        ['description', 'No', '50% off body spray'],
        ['value_adjustment', 'Yes', '30'],
      ],
    },
    {
      title: 'Notes',
      variant: 'notes',
      groups: [
        {
          heading: 'Dates',
          items: [
            'YYYY-MM-DD only',
            'Window is start 00:00 through end 23:59:59 Bangladesh time',
          ],
        },
        {
          heading: 'vendor_id',
          items: [
            'Six-digit integer vendor identifier (e.g. 123456)',
          ],
        },
        {
          heading: 'value_adjustment',
          items: [
            'Vendor-funded BDT per unit sold',
            'Required, 0 or greater, at most 2 decimal places',
            'Do not include Shwapno’s own share of the discount',
          ],
        },
        {
          heading: 'Import behaviour',
          items: [
            'The same article_code may appear more than once in one file when start–end windows do not overlap (for example 1–10 Oct and 11–22 Oct for the same SKU)',
            'If two rows for the same article_code have overlapping dates in one file, the entire upload is rejected and nothing is imported',
            'Across separate uploads, a new window that overlaps an existing active row replaces that slice for the overlapping dates; dates outside the overlap keep the previous amount',
            'Superseded rows remain in Manage Upcoming Promotions for audit and are not deleted',
            'When the import finishes, a results dialog shows successful and failed row counts; failed rows list the error reason (you can also open this from Upload History)',
          ],
        },
      ],
    },
  ],
}

export const divisionDefinitionUploadInstructions = {
  title: 'Format Instructions',
  sections: [
    {
      title: 'Required Columns',
      variant: 'table',
      columns: ['Column', 'Required', 'Example'],
      rows: [['name', 'Yes', 'Loose Commodity']],
    },
    {
      title: 'Notes',
      variant: 'notes',
      groups: [
        {
          heading: 'Import behaviour',
          items: [
            'Existing divisions remain unchanged',
            'New rows create additional division records',
          ],
        },
      ],
    },
  ],
}

export const divisionAssignmentUploadInstructions = {
  title: 'Format Instructions',
  sections: [
    {
      title: 'Required Columns',
      variant: 'table',
      columns: ['Column', 'Required', 'Example'],
      rows: [
        ['Article Code', 'Yes', '2301747'],
        ['Division', 'Yes', 'LOOSE_COMMODITY'],
      ],
    },
    {
      title: 'Notes',
      variant: 'notes',
      groups: [
        {
          heading: 'Import behaviour',
          items: [
            'Only existing products are updated',
            'Invalid rows appear in upload summary and history',
          ],
        },
      ],
    },
  ],
}

export const categoryUploadInstructions = {
  title: 'Format Instructions',
  sections: [
    {
      title: 'Required Columns',
      variant: 'table',
      columns: ['Column', 'Required', 'Example'],
      rows: [
        ['name', 'Yes', 'Fresh Fruits'],
        ['image_url', 'No', 'https://cdn.example.com/categories/fresh-fruits.jpg'],
      ],
    },
  ],
}

export const promotionsUploadInstructions = {
  title: 'Format Instructions',
  sections: [
    {
      title: 'Required Columns',
      variant: 'table',
      columns: ['Column', 'Required', 'Example'],
      rows: [
        ['Article Code', 'Yes', '2301747'],
        ['Regular MRP', 'Yes', '500'],
        ['Discount Value', 'Yes', '50'],
        ['Discount Type', 'Yes', 'Amount'],
        ['CONDITION', 'Yes', 'BUY 1'],
        ['Start', 'Yes', '2026-02-18'],
        ['End', 'Yes', '2026-02-25'],
        ['Type', 'Yes', 'Sales'],
        ['Description', 'No', 'Weekend offer'],
        ['System Configure', 'No', ''],
        ['Outlets', 'No', ''],
        ['Promo Mode', 'No', ''],
        ['Bar', 'No', ''],
      ],
    },
    {
      title: 'Notes',
      variant: 'notes',
      groups: [
        {
          heading: 'Discount Type',
          items: ['Amount', 'Percentage'],
        },
        {
          heading: 'Discount Value',
          items: [
            'Percentage must be between 0 and 100',
            'Amount must be less than Regular MRP (promotional price cannot be zero or negative)',
          ],
        },
        {
          heading: 'Type',
          items: ['Sales', 'Purchase'],
        },
        {
          heading: 'Optional columns',
          items: ['Description, System Configure, Outlets, Promo Mode, Bar are stored in meta'],
        },
      ],
    },
  ],
}

export const locationUploadInstructions = {
  title: 'Format Instructions',
  sections: [
    {
      title: 'Required Columns',
      variant: 'table',
      columns: ['Column', 'Required', 'Example'],
      rows: [
        ['name', 'Yes', 'Gulshan Center'],
        ['code', 'Yes', 'LOC-GUL'],
        ['geolocation', 'No', '23.7925,90.4078'],
      ],
    },
    {
      title: 'Notes',
      variant: 'notes',
      groups: [
        {
          heading: 'Geolocation format',
          items: ['latitude,longitude', '23.8103,90.4125'],
        },
      ],
    },
  ],
}

export const deliveryTimeUploadInstructions = {
  title: 'Format Instructions',
  sections: [
    {
      title: 'Required Columns',
      variant: 'table',
      columns: ['Column', 'Required', 'Example'],
      rows: [
        ['Shop Id', 'Yes', '1'],
        ['Shop Name', 'No', 'Gulshan Store'],
        ['Location ID', 'Yes', '12'],
        ['min_delivery_time', 'Yes', '1'],
        ['min_delivery_unit', 'Yes', 'day'],
        ['max_delivery_time', 'Yes', '3'],
        ['max_delivery_unit', 'Yes', 'day'],
      ],
    },
    {
      title: 'Notes',
      variant: 'notes',
      groups: [
        {
          heading: 'Getting started',
          items: [
            'Download missing combinations CSV',
            'Fill min/max delivery time values before upload',
          ],
        },
        {
          heading: 'Accepted units',
          items: ['hour', 'day', 'week'],
        },
      ],
    },
  ],
}

export const inventoryUploadInstructions = {
  title: 'Format Instructions',
  sections: [
    {
      title: 'Required Columns',
      variant: 'table',
      columns: ['Column', 'Required', 'Example'],
      rows: [
        ['article_code', 'Yes', 'SKU-001'],
        ['quantity_on_hand', 'Yes', '150'],
        ['unit_cost', 'Yes', '15.50'],
        ['unit_price', 'Yes', '25.99'],
        ['location_code', 'Yes', 'warehouse_a'],
        ['min_processing_time', 'No', '1'],
        ['min_processing_unit', 'No', 'day'],
        ['max_processing_time', 'No', '1'],
        ['max_processing_unit', 'No', 'week'],
        ['minimum_stock_level', 'No', '20'],
        ['maximum_stock_level', 'No', '500'],
        ['reorder_point', 'No', '100'],
        ['notes', 'No', 'Stock checked'],
      ],
    },
    {
      title: 'Notes',
      variant: 'notes',
      groups: [
        {
          heading: 'Accepted units',
          items: ['hour', 'day', 'week'],
        },
        {
          heading: 'Import behaviour',
          items: [
            'Products must already exist and be published',
            'Selling Price (unit_cost) and MRP (unit_price) are required for inventory records',
          ],
        },
      ],
    },
  ],
}

export const purchasableStatusUploadInstructions = {
  title: 'Format Instructions',
  sections: [
    {
      title: 'Required Columns',
      variant: 'table',
      columns: ['Column', 'Required', 'Example'],
      rows: [['Article Code', 'Yes', '2100048']],
    },
    {
      title: 'Notes',
      variant: 'notes',
      groups: [
        {
          heading: 'What this upload does',
          items: [
            'Each article code is checked with Shwapno in batches of 20',
            'Status 1 sets the product as purchasable',
            'Status 0 sets the product as not purchasable',
            'Unknown article codes and missing statuses are recorded as row errors',
            'The rest of the file still completes',
          ],
        },
      ],
    },
  ],
}

export const productUploadInstructions = {
  title: 'Format Instructions',
  sections: [
    {
      title: 'Required Columns',
      variant: 'table',
      columns: ['Column', 'Required', 'Example'],
      rows: [
        ['article_code', 'Yes for shwapno; optional for external', 'AC-001'],
        ['product_name', 'Yes', 'iPhone 15 Pro'],
        ['category', 'Yes', 'Electronics'],
        ['source', 'Yes', 'shwapno'],
        ['division', 'No', 'LOOSE_COMMODITY'],
        ['description', 'No', 'Latest Apple smartphone'],
        ['barcode', 'No', '1234567890123'],
        ['brand', 'No', 'Apple'],
        ['company_rate', 'No', '750.00'],
        ['tax_category', 'No', 'electronics'],
        ['vat', 'Yes for shwapno; optional for external', '15'],
        ['dsd', 'No (defaults to 0 / Not DSD)', '0'],
        ['unit_of_measure', 'No', 'piece'],
        ['pack_size', 'No', '24'],
        ['pack_type', 'No', 'carton'],
        ['tp_map', 'No', 'TP 999 / MAP 1099'],
        ['logo_image', 'No', 'https://picsum.photos/200'],
        ['portrait_image', 'No', 'https://picsum.photos/200'],
        ['banner_image', 'No', 'https://picsum.photos/200'],
        ['additional_images', 'No', '["https://picsum.photos/200"]'],
      ],
    },
    {
      title: 'Notes',
      variant: 'notes',
      groups: [
        {
          heading: 'Image URLs',
          items: [
            'Use valid HTTP/HTTPS URLs',
            'additional_images should be a JSON array of URLs',
          ],
        },
        {
          heading: 'Article code by source',
          items: [
            'shwapno: article_code is required',
            'external: leave article_code blank to auto-assign a system code, or provide your own unique code',
          ],
        },
        {
          heading: 'VAT%',
          items: [
            'Column aliases: vat, vat %, or vat%',
            'Mandatory for source=shwapno; optional for external (omit or leave blank)',
            'Allowed range: 0–100 inclusive, at most 2 decimal places; 0 is valid',
            'Invalid or missing Shwapno VAT% fails that row (backend validation is authoritative)',
          ],
        },
        {
          heading: 'DSD',
          items: [
            'Optional; use 0 (Not DSD) or 1 (DSD) only — other values are rejected',
            'Empty / missing DSD defaults to 0 (Not DSD)',
            'Only shwapno products may set DSD to 1; external with 1 fails that row',
          ],
        },
        {
          heading: 'Pricing note',
          items: ['Set Selling Price (unit_cost) and MRP (unit_price) from inventory after product creation'],
        },
        {
          heading: 'Pack size & type',
          items: [
            'pack_size: optional whole number greater than 0 (units per pack)',
            'pack_type: optional — carton, poly, or sack (case-insensitive)',
          ],
        },
      ],
    },
  ],
}
